import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  width: 100%;
  height: 100%;
`;

const Backdrop = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: rgba(238, 238, 238, 0.6);
  z-index: 1;
`;

const WrapperStyles = {
  zIndex: '1',
  position: 'absolute',
  top: '40%',
  left: '50%',
  transform: 'translate(-40%, -50%)',
};

export { Container, Backdrop, WrapperStyles };
